import React from 'react';
import { Table as AntdTable } from 'antd';
import {
  TableProps as AntdTableProps,
  ColumnType as AntdTableColumnType,
} from 'antd/lib/table';

import {
  StyledPrimaryHeaderWrapper,
  StyledPrimaryHeaderRow,
  StyledPrimaryHeaderCell,
  StyledPrimaryBodyCell,
} from './StyledComponents';

export interface TableProps<T = any> extends AntdTableProps<T> {
  type?: 'primary';
  hideShadow?: boolean;
}

type Columns<Data> = {
  [K in keyof Data]: {
    dataIndex: K;
    render?: (val: Data[K], record: Data, index: number) => React.ReactNode;
  } & Omit<AntdTableColumnType<Data>, 'dataIndex' | 'render'>;
}[keyof Data];

// Hacky solution for undefined dataIndex since undefined can't be discriminated without typeguard or strictNullChecks flag
type NoDataIndexColumn<Data> = {
  dataIndex?: '';
  render?: (val: undefined, record: Data, index: number) => React.ReactNode;
} & Omit<AntdTableColumnType<Data>, 'dataIndex' | 'render'>;

export type TableColumnType<Data> = Columns<Data> | NoDataIndexColumn<Data>;

export const Table: React.FC<TableProps> = ({
  type,
  hideShadow = false,
  components,
  ...props
}) => {
  const getComponents = () => {
    if (type === 'primary') {
      return {
        components: {
          header: {
            wrapper: (wrapperProps: any) => (
              <StyledPrimaryHeaderWrapper
                {...wrapperProps}
                $hideShadow={hideShadow}
              />
            ),
            row: StyledPrimaryHeaderRow,
            cell: StyledPrimaryHeaderCell,
          },
          body: {
            cell: StyledPrimaryBodyCell,
          },
          ...components,
        },
      };
    }
    return { components };
  };

  return <AntdTable {...props} {...getComponents()} />;
};
export default Table;
